module.exports = __webpack_public_path__ + "static/David-Braunstein-b46498221169d0faa1b0f7437f54e551.jpg";